// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__AVbJu","rootSuccess":"CompleteLink_rootSuccess__2yk0q","rootFailure":"CompleteLink_rootFailure__1XPSX","isDisabled":"CompleteLink_isDisabled__20vr_"};